// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SeasonalDiscountUnibrow-cls1___b2771f81c297f727fe9{/*!*/}.SeasonalDiscountUnibrow-cls2__b150afdf5add9b8fc429{align-items:center;display:flex;grid-gap:20px;gap:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SeasonalDiscountUnibrow-cls1___b2771f81c297f727fe9",
	"cls2": "SeasonalDiscountUnibrow-cls2__b150afdf5add9b8fc429 SeasonalDiscountUnibrow-cls1___b2771f81c297f727fe9"
};
export default ___CSS_LOADER_EXPORT___;
